import { render, staticRenderFns } from "./index.vue?vue&type=template&id=64424494"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AdminCategoryToolbar: require('/app/components/AdminCategoryToolbar.vue').default,Breadcrumb: require('/app/components/Breadcrumb.vue').default,BreadcrumbStructuredData: require('/app/components/BreadcrumbStructuredData.vue').default,CategoryHubSkeleton: require('/app/components/CategoryHubSkeleton.vue').default,Category: require('/app/components/Category.vue').default})
